/**
 * Client site constants that are safe to import in both frontend and backend.
 * These are pure TypeScript constants with no dependencies on Node.js modules.
 */

export const ClientSiteStatus = {
  Active: 'active',
  Inactive: 'inactive',
  Suspended: 'suspended',
} as const

// TypeScript types
export type ClientSiteStatusValue = (typeof ClientSiteStatus)[keyof typeof ClientSiteStatus]
